services.service('OpenTradeService', [
    '$rootScope', '$q', '$log',
    'config', 'constants', 'API', 'ErrorService', 'OpenTradeCollection', 'OpenTradeModel', 'AssetService',
    'UserService', 'Validator', 'Utils', 'Onesignal', 'CustomerEventsService',
    function ($rootScope, $q, $log, config, Const, API, ErrorService, OpenTradeCollection, OpenTradeModel,
              AssetService, UserService, Validator, Utils, Onesignal, CustomerEventsService) {

        var self = this;
        self.collection = new OpenTradeCollection();

        this.init = function () {

            self.collection = new OpenTradeCollection();

            var user = UserService.get();
            if (!user.activeTradingAccount) {
                log('not starting opentrades service');
                return;
            }

            return getOpenTrades()
                .then(checkResponse)
                .then(initTrades)
                .then(subscribe)
                .catch(function (err) {
                    $log.error(new ErrorService({
                        source: 'OpenTradeService',
                        type: Const.error.type.SYSTEM,
                        severity: 'warning',
                        code: 'noOpenTrades',
                        data: {response: err}
                    }));
                });
        };

        function checkResponse(data) {
            if (data.status !== 1 || !data.Trades) {
                return $q.reject(data);
            }
            return data;
        }


        function validateTrade(data) {
            var errors = [],
                rules = config.validations.openTrade;

            var validated = Validator(data, rules);

            if (validated) {
                errors.push({
                    asset: data.OutputName,
                    tradeId: data.OrderID,
                    validations: validated
                })
            }

            if (errors.length > 0) {
                return new ErrorService({
                    source: 'OpenTradeService',
                    severity: 'warning',
                    type: Const.error.type.VALIDATION,
                    message: 'opentrade validation failed',
                    data: errors
                }, true)
            }
        }

        function initTrades(data) {
            data.Trades.forEach(function (trade) {
                var asset = AssetService.collection.get({id: trade.id});
                if (asset && !validateTrade(trade)) {
                    self.collection.add(new OpenTradeModel(trade, asset));
                }
            });
        }

        function getOpenTrades(user) {
            return API.mt4GetOpenPositions();
        }

        function subscribe() {
            log('Starting to listen to trade updates');
            API.subscribe('MT4NewTrade', self.newTrade);
            API.subscribe('MT4CloseTrade', self.closeTrade);
            API.subscribe('MT4UpdateTrade', self.updateTrade);
            API.subscribe('MT4DeletePosition', self.deleteTrade);
        }

        this.newTrade = function (data) {
            if (!filterActiveAccount(data)) return;

            var trade = self.collection.get({orderId: data.Trade.OrderID});
            if (!trade) {
                var asset = AssetService.collection.get({id: data.Trade.id});
                if (asset) {
                    var _trade = new OpenTradeModel(data.Trade, asset);
                    self.collection.add(_trade);
                    $rootScope.$emit('pnl');

                    Onesignal.setTag("last_trade_symbol", _trade.asset.outputName)
                    Onesignal.setTag("last_trade_openprice", _trade.openPrice)
                    Onesignal.setTag("last_trade_opentime", _trade.openTime)
                    Onesignal.setTag("last_trade_volume", _trade.lots)
                    Onesignal.setTag("last_trade_category", _trade.asset.category)

                    CustomerEventsService.trackEvent(CustomerEventsService.events.TradeOpen, _trade.getTrade());
                }
            } else {
                self.updateTrade(data);
            }
        };

        this.closeTrade = function (data) {
            if (!filterActiveAccount(data)) return;

            var trade = self.collection.get({orderId: data.Trade.OrderID});
            if (trade) {
                self.collection.remove(trade);
                $rootScope.$emit('pnl');
                CustomerEventsService.trackEvent(CustomerEventsService.events.TradeClose, trade.getTrade());
            }
        };

        this.updateTrade = function (data) {
            if (!filterActiveAccount(data)) return;

            var trade = self.collection.get({orderId: data.Trade.OrderID});
            if (trade) {
                trade.update(data.Trade);
                $rootScope.$emit('pnl');
                CustomerEventsService.trackEvent(CustomerEventsService.events.TradeUpdate, trade.getTrade());
            }
        };

        this.deleteTrade = function (data) {
            if (!filterActiveAccount(data)) return;

            var trade = self.collection.get({orderId: data.OrderID});
            if (trade) {
                self.collection.remove(trade);
                $rootScope.$emit('pnl');
                CustomerEventsService.trackEvent(CustomerEventsService.events.TradeCancel, trade.getTrade());
            }
        };

        function filterActiveAccount(data) {
            var user = UserService.get();
            return data.login === user.activeTradingAccount.login
                && Utils.toBoolean(data.live) === user.activeTradingAccount.live;
        }

        this.clear = function () {
            log('clear OpenTradeService');
            API.unsubscribe('MT4NewTrade', self.newTrade);
            API.unsubscribe('MT4CloseTrade', self.closeTrade);
            API.unsubscribe('MT4UpdateTrade', self.updateTrade);
            self.collection && self.collection.clear();
            // self.collection = null;
        };

        return this;
    }]);
